<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    罗湖站<br>
站点介绍<br>
罗湖车站为深圳地铁一期工程的起点站，位于罗湖口岸及火车站广场内是连接内地和香港特别行政区的主要陆路通道，也是深圳市主要的对外交通集散地，地理位置十分重要。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	--	--	1号线	2分钟	4分40秒<br>
机场东	06:20	23:00	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	--	--	1号线	3分45秒	5分45秒<br>
机场东	06:20	23:00	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	--	--	1号线	3分45秒	5分45秒<br>
机场东	06:20	00:00	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br>
A1出入口:<br>
罗湖口岸（中国边检）、罗湖长途客运站<br><br>
A2出入口:<br>
罗湖口岸（中国边检）<br><br>
A3出入口:<br>
罗湖口岸（中国边检）、罗湖长途客运站<br><br>
B出入口:<br>
人民南路、公共汽车、出租汽车、沿河南路、行李寄存<br><br>
C出入口:<br>
中华人民共和国深圳海关（中国海关）、和平路、建设路、新都酒店、海关大楼、火车站、火车站西广场<br><br>
D出入口:<br>
广深城际（和谐号）售票处/候车室、海关大楼、火车站西广场<br><br>
E1出入口:<br>
罗湖地铁商业街、火车站下沉广场<br><br>
E2出入口:
罗湖村、人民南路、建设路、香格里拉酒店、汇丰银行（中国）、深圳凯美豪盛酒店、深圳爱康健口腔医院、罗湖口岸保安大队罗湖桥中队<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 火车站<br>
1、101、12、17、M205、215、306、38、82、83、97、E13、E17、K545、M112、M152、M401、M508、N14、N16、N18、高峰专线73号、新西湖快线、K528、<br><br>
D出入口:<br>
公交站名： 火车站西广场<br>
、18、321、61、73、8、M373、M239<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>



